import { useEffect, useState } from "react";
import { Button, Input, Modal } from "@shop-ledger/ui-components";
import { StatusBanner } from "../../components/StatusBanner";

export interface SaveDocumentModalProps {
  open: boolean;
  onClose: () => void;
  initialName: string;
  initialStatus: "DRAFT" | "FINAL";
  saving: boolean;
  errorMessage: string | null;
  onSave: (name: string, status: "DRAFT" | "FINAL") => void;
}

/** Name + Draft/Final prompt shown by DocumentGeneratorPage's "Save" action. */
export function SaveDocumentModal({
  open,
  onClose,
  initialName,
  initialStatus,
  saving,
  errorMessage,
  onSave,
}: SaveDocumentModalProps) {
  const [name, setName] = useState(initialName);
  const [status, setStatus] = useState<"DRAFT" | "FINAL">(initialStatus);

  useEffect(() => {
    if (open) {
      setName(initialName);
      setStatus(initialStatus);
    }
  }, [open, initialName, initialStatus]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Save document"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button type="button" variant="primary" disabled={saving || !name.trim()} onClick={() => onSave(name.trim(), status)}>
            {saving ? "Saving…" : "Save"}
          </Button>
        </>
      }
    >
      <div className="sl-docgen__field-grid">
        <Input label="Document name" value={name} onChange={(event) => setName(event.target.value)} placeholder="e.g. Quote for Acme Ltd" />
      </div>
      <div className="sl-docgen__choice-row" role="group" aria-label="Save as">
        <button
          type="button"
          className={`sl-docgen__choice ${status === "DRAFT" ? "sl-docgen__choice--active" : ""}`}
          onClick={() => setStatus("DRAFT")}
        >
          Draft — keep editing later
        </button>
        <button
          type="button"
          className={`sl-docgen__choice ${status === "FINAL" ? "sl-docgen__choice--active" : ""}`}
          onClick={() => setStatus("FINAL")}
        >
          Final — issued document
        </button>
      </div>
      {errorMessage ? <StatusBanner kind="error">{errorMessage}</StatusBanner> : null}
    </Modal>
  );
}
